import { ComponentProps, FC } from 'react';
import { Anchor, AnchorModel, Link, Text } from '@bpba/ui-components';
import styled from 'styled-components';

type Props = {
  title?: string;
  link?: Link;
};

export const AdditionalLink: FC<Props> = ({ title, link }) => {
  const data = new AnchorModel(0, undefined, link);

  return (
    <Anchor data={data} display="flex" flexDirection="column" alignItems="center" marginTop={'24px'}>
      <StyledText
        lineHeight={['18px', '24px']}
        textAlign={'center'}
        fontWeight="500"
        margin="16px 0 0 0"
        color="primary.0"
        textDecoration="underline"
      >
        {title}
      </StyledText>
    </Anchor>
  );
};

type StyledTextProps = {
  textDecoration?: string;
} & ComponentProps<typeof Text>;

const StyledText = styled(Text)<StyledTextProps>((props) => ({
  textDecoration: props.textDecoration,
}));
